import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Mission from "../pages/mission/page";
import Projects from "../pages/projects/page";
import About from "../pages/about/page";
import PrivacyPolicy from "../pages/legal/privacy/page";
import TermsOfService from "../pages/legal/terms/page";
import CodeOfConduct from "../pages/legal/code-of-conduct/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mission",
    element: <Mission />,
  },
  {
    path: "/projects",
    element: <Projects />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <TermsOfService />,
  },
  {
    path: "/code-of-conduct",
    element: <CodeOfConduct />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
